import React from 'react';
import { Award, Stethoscope, MapPin, Star, Quote } from 'lucide-react';
import PageHero, { Section, CTABlock } from '../components/PageHero';

const doctors = [
  { name: 'Dr. Priya Sharma', role: 'MD Radiology', hospital: 'AIIMS Delhi', batch: 2018, uni: 'Kazan Federal University', story: 'From a Kota tutorial to Kazan corridors — the FMGE-cleared journey.' },
  { name: 'Dr. Rohit Verma', role: 'Cardiologist', hospital: 'Fortis Escorts', batch: 2016, uni: 'Kursk State Medical', story: 'After FMGE, I did DNB Cardiology in Delhi. Russia gave me strong foundations.' },
  { name: 'Dr. Sneha Patel', role: 'General Practitioner', hospital: 'Own Clinic, Surat', batch: 2019, uni: 'Volgograd State Medical', story: 'I now run my own family practice serving 200+ patients weekly.' },
  { name: 'Dr. Karan Mehta', role: 'MD Anaesthesia', hospital: 'Kokilaben Hospital', batch: 2017, uni: 'Bashkir State Medical', story: 'Russian MBBS opened doors I never imagined — including a Mumbai hospital job.' },
  { name: 'Dr. Ananya Reddy', role: 'Paediatrician', hospital: 'Rainbow Children’s Hospital', batch: 2020, uni: 'Rostov State Medical', story: '5 years in Rostov transformed me. Zero regrets, only pride.' },
  { name: 'Dr. Amit Singh', role: 'MS Ortho', hospital: 'Fortis Noida', batch: 2015, uni: 'Kazan Federal University', story: 'From FMGE 2016 to MS Ortho — clarity was everything.' },
  { name: 'Dr. Pooja Nair', role: 'MD Radiology', hospital: 'Apollo Chennai', batch: 2019, uni: 'Kursk State Medical', story: 'Cleared FMGE first attempt. Now practising imaging in Chennai.' },
  { name: 'Dr. Vikram Joshi', role: 'General Surgeon', hospital: 'Manipal Bengaluru', batch: 2018, uni: 'RUDN Moscow', story: 'Moscow experience made me fearless. Surgery came naturally after that.' },
  { name: 'Dr. Shreya Iyer', role: 'MD Dermatology', hospital: 'Own Clinic, Bengaluru', batch: 2020, uni: 'Perm State Medical', story: 'Building my dermatology practice — all thanks to Russian Education’s pathway.' },
];

export default function Alumni() {
  return (
    <>
      <PageHero eyebrow="1,200+ Doctors" title="Our Alumni" highlight="Impact"
        subtitle="Every year, Russian Education alumni join India's finest hospitals, open clinics, and pursue postgraduate specialisations. Meet some of the doctors we’ve proudly guided."
        breadcrumbs={[{ label: 'Alumni' }]} />

      <Section eyebrow="Featured Alumni" title="From Russia to" highlight="India's Top Hospitals">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {doctors.map((d, i) => (
            <div key={i} className="bg-white rounded-2xl border border-border p-6 card-lift">
              <div className="flex items-center gap-3">
                <div className="w-14 h-14 rounded-full bg-brand text-white flex items-center justify-center font-serif font-bold text-lg">
                  {d.name.split(' ').slice(-2).map((s) => s[0]).join('')}
                </div>
                <div>
                  <div className="font-serif text-lg font-bold text-primary leading-tight">{d.name}</div>
                  <div className="text-xs text-muted-foreground">{d.role} · Class of {d.batch}</div>
                </div>
              </div>
              <div className="mt-4 space-y-2 text-xs">
                <div className="flex items-center gap-1.5 text-muted-foreground"><Stethoscope className="w-3.5 h-3.5 text-brand" /> {d.hospital}</div>
                <div className="flex items-center gap-1.5 text-muted-foreground"><MapPin className="w-3.5 h-3.5 text-brand" /> {d.uni}</div>
              </div>
              <div className="mt-4 pt-4 border-t border-border relative">
                <Quote className="absolute -top-2 right-0 w-6 h-6 text-brand/20" strokeWidth={1.5} />
                <p className="text-sm text-foreground italic leading-relaxed">&ldquo;{d.story}&rdquo;</p>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <CTABlock title="Want to join our alumni network?" subtitle="Start your MBBS in Russia today — tomorrow you could be featured here as a practising doctor." />
    </>
  );
}
